import { Button, ButtonProps } from "@mui/material"
import React from "react"
import { Link, LinkProps } from "react-router-dom"

interface ButtonLinkProps extends ButtonProps {
  route: string
  children: React.ReactNode
  fontSize: string
  padding: string
  margin: string
  height: string
}



const ButtonLink: React.FC<ButtonLinkProps> = ({ route, children, fontSize, padding, margin, height, ...props }) => {
  return (
    <Button component={Link as React.ElementType<LinkProps>} to={route} {...props} style={{
      opacity: 1,
      whiteSpace:"nowrap",
      fontSize: fontSize,
      padding: padding,
      margin: margin,
      height: height,
    }}>
      {children}
    </Button>
  )
}

export default ButtonLink
